<div class="ion-padding ion-text-center">
  <ion-icon
    src="../assets/material-symbols/support_agent_24dp.svg"
    class="icon-big"
  ></ion-icon>
</div>

<div class="block-content-round ion-text-center">
  <p>{{ 'help.support_description' | translate }}</p>
  <p>
    <a
      href="tel:+34915560075"
      target="_blank"
    >
      +34 915 560 075
    </a>
    <br />
    ({{ 'help.extension' | translate }} 3)
  </p>
  <p>
    <a
      href="mailto:soporte@okcargo.com"
      target="_blank"
    >
      soporte&#64;okcargo.com
    </a>
  </p>
  @if (appVersionInfo(); as info) {
    <p class="fs-xs">{{ 'help.app_version' | translate }} {{ info.version }}-{{ info.build }}</p>
  }
</div>
